export type DocsEnvironment = 'production' | 'staging';

export type ApiSpecId = 'core-v1' | 'core' | 'sensors';

export type ApiSpec = {
    id: ApiSpecId;
    label: string;
    specUrl: string;
    serverUrl: string;
};

const PRODUCTION_API = 'https://api.production.aws.mobble.io';
const STAGING_API = 'https://api.staging.aws.mobble.io';
const PRODUCTION_SENSORS = 'https://map-sensors.apis.mobble.io';
const STAGING_SENSORS = 'https://esc5ycabwv.ap-southeast-2.awsapprunner.com';

export const DEFAULT_ENVIRONMENT: DocsEnvironment = 'production';
export const DEFAULT_SPEC_ID: ApiSpecId = 'core-v1';

export const API_CATALOG: Record<DocsEnvironment, ApiSpec[]> = {
    production: [
        {
            id: 'core-v1',
            label: 'Core API (v1)',
            specUrl: `${PRODUCTION_API}/v1/docs/openapi.yaml`,
            serverUrl: `${PRODUCTION_API}/v1`,
        },
        {
            id: 'core',
            label: 'Core API',
            specUrl: `${PRODUCTION_API}/docs/openapi.yaml`,
            serverUrl: PRODUCTION_API,
        },
        {
            id: 'sensors',
            label: 'Map Layer & Sensors API',
            specUrl: `${PRODUCTION_SENSORS}/v1/docs/openapi.yaml`,
            serverUrl: PRODUCTION_SENSORS,
        },
    ],
    staging: [
        {
            id: 'core-v1',
            label: 'Core API (v1)',
            specUrl: `${STAGING_API}/v1/docs/openapi.yaml`,
            serverUrl: `${STAGING_API}/v1`,
        },
        {
            id: 'core',
            label: 'Core API',
            specUrl: `${STAGING_API}/docs/openapi.yaml`,
            serverUrl: STAGING_API,
        },
        {
            id: 'sensors',
            label: 'Map Layer & Sensors API',
            specUrl: `${STAGING_SENSORS}/v1/docs/openapi.yaml`,
            serverUrl: STAGING_SENSORS,
        },
    ],
};

export function isMobbleEmail(email: string): boolean {
    return email.trim().toLowerCase().endsWith('@mobble.io');
}

export function getApiSpec(environment: DocsEnvironment, specId: ApiSpecId): ApiSpec {
    const specs = API_CATALOG[environment];
    return specs.find((spec) => spec.id === specId) ?? specs[0];
}
